import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import SmartImg from "./SmartImg";

const CourseCard = ({ course }) => {
  const navigate = useNavigate();

  const handleDetailClick = () => {
    navigate(`/course/${course.id}`);
  };

  return (
    <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden transform hover:-translate-y-1">
      <SmartImg
        src={`/course/${course.image}`}
        fallback={`https://placehold.co/400x200/E0E0E0/000?text=${course.title.replace(/\s/g, "+")}`}
        alt={course.title}
        className="w-full h-48 object-cover rounded-t-xl"
      />
      <div className="p-6">
        <h3 className="text-2xl font-bold text-gray-800 min-h-[60px]">
          {course.title}
        </h3>
        <p className="text-gray-600 text-sm mb-4 line-clamp-3">
          {course.description}
        </p>
        <div className="flex justify-end mt-4">
          <button
            onClick={handleDetailClick}
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-full shadow-md hover:shadow-lg transition-all duration-300 transform hover:scale-105 flex items-center text-sm"
          >
            Xem Chi Tiết <ChevronRight size={16} className="ml-1" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
